import { StyleSheet } from '@react-pdf/renderer';
import { RegisterFont } from '../../TimeSheets/UserOnProject/RegisterFont';

RegisterFont();

export const headerStyle = StyleSheet.create({
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: 15,
    },
    info: {
        flexDirection: 'column',
        rowGap: 6,
    },
    title: {
        fontSize: 16,
        color: '#22262F',
        fontWeight: 500,
        fontStyle: 'underline',
    },
    period: {
        fontSize: 12,
        color: '#455166',
        fontStyle: 'italic',
    },
    image: {
        width: 150,
        height: 30,
    },
});
